import React from 'react'
import { useSelector } from 'react-redux'

import { getLocation } from 'ducks/router'

const useSearchState = () => {
  const { query = {} } = useSelector(getLocation) as { query?: { search?: string } }

  const [search, setSearch] = React.useState(query?.search ?? '')

  return { search, setSearch }
}

export const useSearch = (): [string, React.Dispatch<React.SetStateAction<string>>] => {
  const { search, setSearch } = useSearchState()

  return [search, setSearch]
}
